import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import CustomCloth from "./CustomCloth";
import WeatherTemperature from "./WeatherTemperature";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <h1> {props.data.city}</h1>
      <ul>
        <li>
          <FormattedDate date={props.data.date} />
        </li>
        <li className="text-capitalize">{props.data.description}</li>
      </ul>
      <div className="row">
        <div className="col-6">
          <div className="clearfix">
            <div className="float-left">
              <WeatherIcon code={props.data.icon} size={52} />
            </div>
            <WeatherTemperature celsius={props.data.temperature} />
          </div>
        </div>
        <div className="col-6">
          <ul>
            <li>Recommended cloth to wear: </li>
            <li>
              <CustomCloth temperature={props.data.temperature} />
            </li>
            <li>Feels like: {Math.round(props.data.feels_like)}°C</li>
            <li>Humidity {Math.round(props.data.humidity)}%</li>
            <li>Wind:{Math.round(props.data.wind)}km/h</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
